module.exports = __webpack_public_path__ + "img/titop.7e8d1738.jpg";